import Index from "container/careers/careers.container";
import { useTranslation } from "next-i18next";
import Head from "next/head";

function Careers() {
  const { t } = useTranslation("static-pages");

  return (
    <>
      <Head>
        <title>{t("Careers at Parts Avatar")}</title>
      </Head>
      <Index />
    </>
  );
}

export default Careers;
